<template>
  <el-row class="points-show">
    <el-col :span="20"> 营销活动流程管理 </el-col>
    <el-col :span="4">
      <el-button size="mini" type="primary" @click="openActivity(null)">
        新增活动素材
      </el-button>
    </el-col>
    <el-divider></el-divider>
    <el-row :gutter="20">
      <el-col :span="5">
        <div class="search-view">
          <div>活动名称：</div>
          <el-input
            v-model="searchForm.activityName"
            size="mini"
            placeholder="营销活动名称"
            clearable
          />
        </div>
      </el-col>
      <el-col :span="5">
        <div class="search-view">
          <div>活动简介：</div>
          <el-input
            v-model="searchForm.activityInfo"
            size="mini"
            placeholder="营销活动简介"
            clearable
          />
        </div>
      </el-col>
      <el-col :span="5">
        <div class="search-view">
          <div>活动状态：</div>
          <el-select
            v-model="searchForm.status"
            size="mini"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in testpaperStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <el-button type="primary" size="mini" @click="handleSizeChange()"
          >查询</el-button
        >
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="5">
        <div class="search-view">
          <div>会员id：</div>
          <el-input
            v-model="daochu.memberId"
            size="mini"
            placeholder="请输入会员id"
            clearable
          />
        </div>
      </el-col>
      <el-col :span="5">
        <div class="search-view">
          <div>活动序号：</div>
          <el-input
            v-model="daochu.sopId"
            size="mini"
            placeholder="请输入活动序号"
            clearable
          />
        </div>
      </el-col>
      <el-col :span="8">
        <div class="search-view">
          <div>时间：</div>
          <el-date-picker
            v-model="daochu.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          >
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="5">
        <el-button type="success" size="mini" @click="daochu2()"
          >阅读明细导出</el-button
        >
      </el-col>
    </el-row>
    <el-col :span="24">
      <el-table :data="tableData" :height="tableHeight">
        <el-table-column prop="id" label="活动序号" width="80">
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称" width="180">
        </el-table-column>
        <el-table-column prop="activityLevel" label="活动等级" width="180">
        </el-table-column>
        <el-table-column prop="activityPic" label="活动标图" width="180">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.activityPic + '?x-oss-process=image/resize,w_50'"
              fit="fill"
              :preview-src-list="[scope.row.activityPic]"
            />
          </template>
        </el-table-column>
        <el-table-column prop="status" label="活动标签">
          <template slot-scope="scope">
            <el-tag
              type="info"
              style="margin: 3px"
              v-for="(item, index) in scope.row.matMarkActivityLabels"
              :key="index"
            >
              {{ item.labelDesc }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="活动状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">有效活动</span>
            <span v-if="scope.row.status == 1">无效活动</span>
          </template>
        </el-table-column>
        <el-table-column label="是否显示首页" prop="showStatus">
          <template slot-scope="scope">
            <el-switch
              :active-value="1"
              :inactive-value="0"
              @change="isStatus(scope.row)"
              active-text="显示"
              inactive-text="不显示"
              v-model="scope.row.showStatus"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              plain
              type="primary"
              @click="openChapterDrawer(scope.row)"
              >SOP管理
            </el-button>
            <el-button
              size="mini"
              plain
              type="primary"
              @click="openActivity(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <!-- 分页小组件 -->

    <el-col :span="24">
      <el-pagination
        small
        layout="total,prev, pager, next"
        :page-size="pageSize"
        :total="total"
        :current-page.sync="pageNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-col>
    <!-- 活动增改 -->
    <el-col :span="24">
      <el-dialog
        title="活动增加/修改"
        @close="offDialog"
        width="50%"
        :visible.sync="ActivityFormVisible"
      >
        <el-form
          :model="ActivityForm"
          label-width="120px"
          ref="ActivityForm"
          :rules="ActivityFormRule"
        >
          <el-form-item prop="pic" label="活动图片:">
            <!-- <el-radio-group v-model="radioValue" @input="chooseRadio(1)">
							<el-radio :label="0">本地上传</el-radio>
							<el-radio :label="1">图片库上传</el-radio>
						</el-radio-group> -->
            <el-button
              @click="chooseRadio(1)"
              type="primary"
              size="mini"
              style="margin-bottom: 10px"
            >
              图片库上传
            </el-button>
            <el-upload
              class="hide"
              :action="uploadUrl"
              list-type="picture-card"
              :limit="1"
              :on-success="getPictrueURL"
              accept=".jpg,.png,.mp4,.avi"
              :file-list="ActivityForm.activityPicList"
              :on-remove="handleRemove"
              :on-change="uponChange"
              v-if="ActivityForm.activityPicList"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="活动标题:" prop="activityName">
            <el-input
              size="mini"
              v-model="ActivityForm.activityName"
              placeholder="请输入标题"
              style="width: 220px"
            />
          </el-form-item>
          <el-form-item label="活动简介:" prop="content">
            <wangeditor
              v-model="ActivityForm.activityInfo"
              style="width: 100%; margin: 0"
              ref="wangeditor"
            />

            <!-- <el-input  type="textarea" v-model="ActivityForm.activityInfo"  placeholder="请输入简介" style="width:220px"></el-input> -->
          </el-form-item>
          <el-form-item label="是否有效:" prop="status">
            <el-radio-group v-model="ActivityForm.status" size="mini">
              <el-radio :label="0">有效</el-radio>
              <el-radio :label="1">无效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动等级:" prop="activityName">
            <el-select
              v-model="ActivityForm.activityLevel"
              size="mini"
              filterable
              placeholder="请输入活动等级"
            >
              <el-option
                v-for="item in activityLevelList"
                :key="item.dicId"
                :label="item.dicDesc"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div
            style="display: flex; width: 80%; flex-wrap: wrap; padding: 10px"
          >
            <el-tag
              size="mini"
              style="margin: 2px"
              v-for="(item, index) in ActivityForm.userTypeLabels"
              @close="delBq(2, index)"
              :key="index"
            >
              {{ item.dicDesc }}
            </el-tag>
          </div>

          <el-form-item label="用户特征">
            <el-select
              v-model="userTypeLabels"
              size="mini"
              filterable
              placeholder="请搜索"
            >
              <el-option
                v-for="item in userTypeLabelsList"
                :key="item.dicId"
                :label="item.dicDesc"
                :value="item.dicId"
              >
              </el-option>
            </el-select>
            <el-button
              size="mini"
              type="primary"
              round
              @click="searchFromChange(2)"
              >增加</el-button
            >
          </el-form-item>
          <!-- 诉求标签 -->
          <div
            style="display: flex; width: 80%; flex-wrap: wrap; padding: 10px"
          >
            <el-tag
              size="mini"
              style="margin: 2px"
              v-for="(item, index) in ActivityForm.userAppealLabels"
              @close="delBq(1, index)"
              :key="index"
            >
              {{ item.dicDesc }}
            </el-tag>
          </div>
          <el-form-item label="用户诉求">
            <el-select
              v-model="userAppealLabels"
              size="mini"
              filterable
              placeholder="请搜索"
            >
              <el-option
                v-for="item in userAppealLabelsList"
                :key="item.dicId"
                :label="item.dicDesc"
                :value="item.dicId"
              >
              </el-option>
            </el-select>
            <el-button
              size="mini"
              type="primary"
              round
              @click="searchFromChange(1)"
              >增加</el-button
            >
          </el-form-item>
          <el-form-item label="活动路径" prop="activityUrl">
            <el-input
              v-model="ActivityForm.activityUrl"
              placeholder="请输入活动路径"
              style="width: 220px"
              size="mini"
            />
          </el-form-item>
          <el-form-item label="活动周期" prop="cycleTime">
            <el-input
              v-model="ActivityForm.cycleTime"
              type="number"
              placeholder="请输入活动周期"
              style="width: 220px"
              size="mini"
            />天
          </el-form-item>
        </el-form>
        <div style="width: 100%; text-align: center">
          <el-button
            v-if="ActivityForm.id == ''"
            type="primary"
            @click="submitFromData('ActivityForm')"
            >添加
          </el-button>
          <el-button
            v-if="ActivityForm.id != ''"
            type="primary"
            @click="submitFromData('ActivityForm')"
            >修改
          </el-button>
        </div>
      </el-dialog>
    </el-col>
    <!-- SOP管理 -->
    <el-col :span="24">
      <el-drawer
        :title="title"
        :visible.sync="testpaperDrawer"
        direction="btt"
        :before-close="closeTestpaperDrawer"
        size="100%"
      >
        <el-container style="margin-left: 10px">
          <el-aside width="400px">
            <h3 class="el-icon-s-operation" style="font-weight: 800">
              活动流程维护
            </h3>
            <el-menu
              :unique-opened="true"
              style="width: 98%; height: 80vh"
              background-color="#dee1e6"
            >
              <div
                v-for="MatMarkModular in MatMarkModularList"
                :key="MatMarkModular.id"
              >
                <el-submenu
                  :index="MatMarkModular.modularName"
                  style="height: auto"
                >
                  <template slot="title">
                    <i class="el-icon-bank-card"></i>
                    <div
                      @click="changeMatMarkModular(MatMarkModular.id)"
                      class="chaochu"
                    >
                      {{ MatMarkModular.modularName }}
                    </div>
                    <div style="margin-left: 10px">
                      <el-button
                        type="text"
                        style="color: #727477"
                        @click.stop="
                          increaseModelOrPrecssOrSetp(
                            MatMarkModular,
                            'matMarkModular'
                          )
                        "
                      >
                        修改
                      </el-button>
                      <el-button
                        type="text"
                        style="color: #727477"
                        @click.stop="
                          removeModelOrPrecssOrSetp(
                            MatMarkModular,
                            'matMarkModular'
                          )
                        "
                      >
                        删除
                      </el-button>
                    </div>
                  </template>
                  <el-menu-item
                    v-for="matMarkProcess in matMarkProcessList"
                    :key="matMarkProcess.id"
                    :index="matMarkProcess.processName"
                  >
                    <template slot="title">
                      <div
                        @click="changeMatMarkProcess(matMarkProcess.id)"
                        class="chaochu"
                      >
                        # {{ matMarkProcess.processName }}
                      </div>
                      <el-button
                        type="text"
                        @click="
                          increaseModelOrPrecssOrSetp(
                            matMarkProcess,
                            'matMarkProcess'
                          )
                        "
                      >
                        修改
                      </el-button>
                      <el-button
                        type="text"
                        @click="
                          removeModelOrPrecssOrSetp(
                            matMarkProcess,
                            'matMarkProcess'
                          )
                        "
                      >
                        删除
                      </el-button>
                    </template>
                  </el-menu-item>
                  <el-button
                    style="margin-left: 50px"
                    :disabled="MatMarkModularList.length == 0"
                    type="text"
                    @click="increaseModelOrPrecssOrSetp(null, 'matMarkProcess')"
                  >
                    添加流程</el-button
                  >
                </el-submenu>
              </div>
              <el-button
                size="mini"
                style="margin: 10px"
                type="success"
                @click="increaseModelOrPrecssOrSetp(null, 'matMarkModular')"
                >添加模块</el-button
              >
            </el-menu>
          </el-aside>
          <el-container>
            <el-header
              style="display: flex; align-items: center; padding-left: 20px"
            >
              {{ title }}素材包 >> 子流程2
            </el-header>
            <el-main>
              <el-col :span="6" style="background-color: #f0f2f8">
                <el-row>
                  <el-col :span="24">
                    <h3 class="el-icon-s-grid" style="font-weight: 800">
                      活动阶段维护
                    </h3>
                    <el-button
                      size="mini"
                      style="margin-left: 10px"
                      type="success"
                      @click="increaseModelOrPrecssOrSetp(null, 'matMarkStep')"
                    >
                      添加步骤
                    </el-button>
                  </el-col>

                  <el-table :data="MatMarkStepList" :show-header="false">
                    <el-table-column>
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click="changeMatMarkStep(scope.row.id)"
                        >
                          {{ scope.row.stepName }}
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template slot-scope="scope">
                        <el-button
                          icon="el-icon-edit"
                          circle
                          size="mini"
                          @click="
                            increaseModelOrPrecssOrSetp(
                              scope.row,
                              'matMarkStep'
                            )
                          "
                        >
                        </el-button>
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          @click="
                            removeModelOrPrecssOrSetp(scope.row, 'matMarkStep')
                          "
                          circle
                          size="mini"
                        ></el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-col>
              <el-col :span="18" style="display: flex; flex-wrap: wrap">
                <el-row>
                  <el-col :span="24">
                    <h3 style="font-weight: 800">步骤素材维护</h3>
                    <el-button
                      size="mini"
                      style="margin-left: 10px"
                      type="success"
                      @click="openMatInsOrUpdate(null)"
                      >添加素材</el-button
                    >
                  </el-col>
                  <el-col :span="24">
                    <el-table :data="MatMarkMaterialList" style="width: 1000px">
                      <el-table-column prop="matId" label="素材编号">
                      </el-table-column>
                      <el-table-column prop="matId" label="素材内容">
                        <template slot-scope="scope">
                          <el-image
                            v-if="scope.row.matImg.length > 0"
                            :src="
                              scope.row.matImg.split(',')[0] +
                              '?x-oss-process=image/resize,w_50'
                            "
                            fit="fill"
                            :preview-src-list="scope.row.matImg.split(',')"
                          />
                          <div
                            v-else-if="
                              scope.row.matStyle == 2 || scope.row.matStyle == 1
                            "
                          >
                            讲解类内容请点击右侧编辑查看详情
                          </div>
                          <div v-else>{{ scope.row.matInfo }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="matStyle" label="素材形式">
                        <template slot-scope="scope">
                          {{ matStyleList[scope.row.matStyle] }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            type="primary"
                            icon="el-icon-edit"
                            circle
                            @click="openMatInsOrUpdate(scope.row)"
                          ></el-button>
                          <el-button
                            type="danger"
                            icon="el-icon-delete"
                            circle
                            @click="delSucai(scope.row)"
                          ></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </el-col>
            </el-main>
          </el-container>
        </el-container>
        <!-- 增加模块/流程/步骤 -->
        <el-col :span="24">
          <el-dialog
            :title="incParam.addMOPOSTitle"
            :visible.sync="increaseModelOrPrecssOrSetpStatus"
            :modal="false"
            width="30%"
            center
          >
            <el-form label-position="right" label-width="100px">
              <el-form-item :label="incParam.addMOPOSInputName">
                <el-input
                  style="width: 200px"
                  clearable
                  size="mini"
                  v-model="incParam.name"
                >
                </el-input>
              </el-form-item>
              <div v-if="incParam.spuList">
                <div
                  v-for="(item, index) in incParam.spuList"
                  :key="index"
                  class="biaoqian"
                >
                  <div>{{ item }}</div>
                  <i
                    class="el-icon-close close"
                    :data-index="index"
                    @click="delGoodsId"
                  ></i>
                </div>
              </div>
              <el-form-item
                :label="incParam.goodsInputName"
                v-if="incParam.goodsInputName"
              >
                <template>
                  <el-input
                    style="width: 200px"
                    clearable
                    size="mini"
                    v-model="incParam.goodsId"
                  >
                  </el-input>
                  <el-button
                    size="mini"
                    style="margin-left: 10px"
                    @click="addGoodsId"
                    >新增</el-button
                  >
                </template>
              </el-form-item>
              <el-form-item label="时间">
                <el-date-picker
                  v-model="incParam.timeVlaue"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <!-- <div style="text-align: center;">

						</div>
						<div style="text-align: center;"> 选择时间

						</div> -->
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="operationMatMark()"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </el-col>
        <!-- 增加素材的窗口 -->
        <el-col :span="24">
          <el-drawer
            title="增加/编辑步骤素材"
            size="92%"
            :append-to-body="true"
            :before-close="closeSonUpdate"
            :visible.sync="innerSonDrawer"
          >
            <div>
              <el-col :span="20" :offset="2">
                <el-form :model="matForm" style="width: 46%">
                  <!-- 选择素材标签 -->
                  <el-form-item label="素材类型">
                    <el-radio-group v-model="matForm.matStyle">
                      <el-radio :label="1">步骤讲解</el-radio>
                      <el-radio :label="2">社群讲解</el-radio>
                      <el-radio :label="3">圈文素材</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <!-- 圈文图片 -->
                  <el-form-item label="上传图片" v-show="matForm.matStyle == 3">
                    <!-- <el-radio-group v-model="radioValue" @input="chooseRadio(9)">
											<el-radio :label="0">本地上传</el-radio>
											<el-radio :label="1">图片库上传</el-radio>
										</el-radio-group> -->
                    <el-button
                      @click="chooseRadio(9)"
                      type="primary"
                      size="mini"
                      style="margin-bottom: 10px"
                    >
                      图片库上传
                    </el-button>
                    <el-upload
                      :class="{ hide: true }"
                      :action="uploadUrl"
                      :multiple="true"
                      list-type="picture-card"
                      :limit="9"
                      :on-success="getMatPictrueURL"
                      accept=".jpg,.png,.jpeg"
                      :file-list="fileList"
                      :on-remove="handleMatRemove"
                      :on-error="handleError"
                      v-if="fileList.length > 0"
                    >
                      <i class="el-icon-plus" />
                    </el-upload>
                  </el-form-item>
                  <!-- 圈文输入文案的地方 -->
                  <el-form-item label="圈文短句" v-show="matForm.matStyle == 3">
                    <el-input
                      type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="matForm.matInfo"
                    >
                    </el-input>
                  </el-form-item>
                  <!-- 文章圈文类的 -->
                  <el-form-item
                    label=""
                    v-show="matForm.matStyle == 2 || matForm.matStyle == 1"
                  >
                    <wangeditor
                      v-model="matForm.matInfo"
                      style="width: 100%; margin: 0"
                      ref="wangeditor"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" @click="closeSonUpdate"
                      >取 消</el-button
                    >
                    <el-button size="mini" type="primary" @click="addSonMat"
                      >确 定</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </el-drawer>
        </el-col>
      </el-drawer>
    </el-col>
    <el-drawer
      title="选择图片"
      :visible.sync="isSelectPicture"
      direction="rtl"
      size="40%"
    >
      <SelectPicture :imgNum="imgNum" @imgList="getImg" />
    </el-drawer>
  </el-row>
</template>

<script>
import httpClient from "../../../util/request.js";
import wangeditor from "../../../components/wangEditor/wangEditor.vue";
import SelectPicture from "../../../components/SelectPicture/index.vue";
export default {
  components: {
    wangeditor,
    SelectPicture,
  },
  data() {
    return {
      radioValue: 0,
      title: "",
      isSelectPicture: false,
      imgNum: 1,
      daochu: {
        memberId: "",
        sopId: "",
        time: [],
      },
      // 素材形式
      matStyleList: {
        1: "步骤讲解",
        2: "社群讲解",
        3: "圈文素材",
      },
      // 分页组件
      pageNum: 1,
      pageSize: 15,
      hideUpload: false, //隐藏上传图片框
      total: null,
      // table 自适应高度
      tableHeight: window.innerHeight - 300,
      uploadUrl: httpClient.imgUrl,
      tableData: [],
      testpaperStatus: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "无效活动",
          value: "1",
        },
        {
          label: "有效活动",
          value: "0",
        },
      ],
      // SOP打开关闭
      testpaperDrawer: false,
      // 活动编辑增加打开关闭
      ActivityFormVisible: false,
      formLabelWidth: "120px",
      searchForm: {
        activityName: "",
        activityInfo: "",
        status: "",
      },
      ActivityFormRule: {
        //表单验证规则
        activityPic: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        activityName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
        ],
        activityInfo: [
          {
            required: true,
            message: "请输入活动简介",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "选择是否有效",
            trigger: "change",
          },
        ],
        activityUrl: [
          {
            required: true,
            message: "请输入活动路径",
            trigger: "change",
          },
        ],
        cycleTime: [
          {
            required: true,
            message: "请输入活动路周期",
            trigger: "change",
          },
        ],
      },
      ActivityForm: {
        activityName: "",
        activityInfo: "",
        activityPic: "",
        activityPicList: [],
        status: 0,
        id: "",
        userTypeLabels: [], //用户特征标签组
        userAppealLabels: [], //用户诉求标签组
        orders: 0,
        activityUrl: "", //活动路径
        cycleTime: "", //活动周期
        activityLevel: "",
      },
      //1-用户诉求标签组
      userAppealLabelsList: [],
      userAppealLabels: "",
      searchUserAppea: [],
      //2-用户特性标签组
      userTypeLabelsList: [],
      //活动等级
      activityLevelList: ["S", "A", "B"],
      userTypeLabels: "",
      searchUserType: [],
      // 模块的列表
      MatMarkModularLoading: false,
      MatMarkModularList: [],
      MatMarkModularId: "",
      // 流程的列表
      matMarkProcessLoading: false,
      matMarkProcessList: [],
      matMarkProcessId: "",
      //步骤的列表
      MatMarkStepLoading: false,
      MatMarkStepList: [],
      MatMarkStepId: "",
      // 素材的列表
      MatMarkMaterialLoading: false,
      MatMarkMaterialList: [],
      MatMarkMaterialId: "",
      // 监听的
      setListenDragging: "",
      changeList: "",
      // 增加三项流程信息
      increaseModelOrPrecssOrSetpStatus: false,
      incParam: {
        addMOPOSTitle: "",
        addMOPOSInputName: "",
        name: "",
        id: null,
        pid: "",
        type: "",
        timeValue: [],
      },
      // 素材的from

      matForm: {
        matId: "", //素材的ID
        matImg: "", //图片或视频地址
        matInfo: "", //文案或者话术
        matStyle: 1,
        status: 0,
        stepId: 0,
      },
      fileList: [],
      innerSonDrawer: false,
    };
  },
  created() {
    this.query();
    this.getScatteredDicAll();
  },
  mounted() {
    this.listenDragging();
  },
  methods: {
    isStatus(row) {
      this.openActivity(row, 1);
      var newobj = {
        ...this.ActivityForm,
        activityPic: this.ActivityForm.activityPicList[0].url,
      };
      var url = "/api/plant/matMarkModular/updateActivity";
      var matMarkActivityLabels = [];
      if (newobj.userAppealLabels.length > 0) {
        newobj.userAppealLabels.forEach((element) => {
          var thisP = {
            labelType: 2,
            labelValue: element.dicId,
            labelDesc: element.dicDesc,
          };
          if (newobj.id != null && newobj.id != "") {
            thisP.activityId = newobj.id;
          }
          matMarkActivityLabels.push(thisP);
        });
      }
      if (newobj.userTypeLabels.length > 0) {
        newobj.userTypeLabels.forEach((element) => {
          var thisP = {
            labelType: 1,
            labelValue: element.dicId,
            labelDesc: element.dicDesc,
          };
          if (newobj.id != null && newobj.id != "") {
            thisP.activityId = newobj.id;
          }
          matMarkActivityLabels.push(thisP);
        });
      }
      newobj.matMarkActivityLabels = matMarkActivityLabels;
      newobj.showStatus = row.showStatus;
      this.$http.post(url, newobj).then((res) => {
        if (res.data.status == 0) {
          this.handleSizeChange();
          this.offDialog();
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg || "请求错误");
        }
      });
    },
    delGoodsId(e) {
      console.log(e.target.dataset.index);
      var index = e.target.dataset.index;
      this.incParam.spuList.splice(index, 1);
    },
    addGoodsId() {
      if (this.incParam.goodsId == "")
        return this.$message.error("请填写正确的商品ID");
      var index = this.incParam.spuList.findIndex(
        (item) => item == this.incParam.goodsId
      );
      if (index != -1) return this.$message.error("请勿添加重复的商品ID");
      this.incParam.spuList.push(this.incParam.goodsId);
      this.incParam.goodsId = "";
    },
    chooseRadio(num) {
      this.imgNum = num;
      this.isSelectPicture = true;
    },
    getImg(e) {
      console.log(e);
      this.ActivityForm.activityPicList = [];
      this.matForm.matImg = "";
      this.fileList = [];
      this.matForm.matImg = e;
      e.split(",").forEach((item) => {
        this.ActivityForm.activityPicList.push({
          url: item,
        });
        this.fileList.push({
          url: item,
        });
      });
      this.isSelectPicture = false;
    },
    delBq(num, index) {
      switch (num) {
        case 1:
          console.log(this.ActivityForm.userAppealLabels);
          console.log(this.userAppealLabels);
          break;
        case 2:
          console.log(this.ActivityForm.userTypeLabels);
          console.log(this.userTypeLabels);
          break;
      }
    },
    delSucai(row) {
      console.log(row);
      this.$confirm("此操作将永久删除该素材, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get("/api/plant/matMarkMaterial/del/" + row.matId, {})
            .then((res) => {
              console.log(res.data.status == 0);
              if (res.data.status == 0) {
                this.getMatMarkMaterialList(this.MatMarkStepId);
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    daochu2() {
      var startTime = "";
      var endTime = "";
      if (this.daochu.time.length == 0) {
        this.$message.error("请选择时间");
        return false;
      }
      startTime = this.daochu.time[0];
      endTime = this.daochu.time[1];
      this.$http
        .post(
          "/api/plant/matMarkModular/exportMatMarkLog",
          {
            memberId: this.daochu.memberId, //会员ID
            sopId: this.daochu.sopId,
            startTime: startTime, //开始时间
            endTime: endTime, //结束时间
          },
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          console.log(res);
          this.$message({
            type: "info",
            message: "正在导出表格",
          });
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          //设置连接
          link.href = URL.createObjectURL(blob);
          link.download = "sop浏览记录";
          document.body.appendChild(link);
          //模拟点击事件
          link.click();
          window.URL.revokeObjectURL(link.href);
          link.remove();
        });
    },
    // 操作素材
    openMatInsOrUpdate(row) {
      console.log();
      this.resetFrom();
      if (row != null) {
        row.matImg.split(",").forEach((item) => {
          this.fileList.push({
            url: item,
          });
        });
        // 参数太多了。还是单独组装吧。不然很难看
        this.matForm = {
          matId: row.matId,
          matImg: row.matImg,
          matInfo: row.matInfo,
          matStyle: row.matStyle,
          status: row.status,
          stepId: row.stepId,
        };
      } else {
        this.matForm.stepId = this.MatMarkStepId;
      }
      this.innerSonDrawer = true;
    },
    addSonMat() {
      // 素材也在了
      var param = this.matForm;
      if (param.matStyle == 1 || param.matStyle == 2) {
        if (param.matInfo == "") {
          this.$message.warning("请填写讲解内容哦~");
          return;
        }
      }
      if (param.matStyle == 3) {
        if (param.matImg == "" || param.matInfo == "") {
          this.$message.warning("请上传图片以及填写圈文内容");
          return;
        }
      }
      if (param.matImg != "") {
        param.matImg.substring(0, 1) == ","
          ? (param.matImg = param.matImg.substring(1, param.matImg.length))
          : "";
      }
      if (param.matId == "") {
        param.memberId = this.$store.state.memberId;
      }
      param.deleteStatus = 0;
      // 组装URL
      var url =
        "/api/source/matMarkMaterial/" +
        (param.matId == "" ? "insert" : "update");
      // 进行请求
      this.$http.post(url, param).then((res) => {
        if (res.data.status == 0) {
          console.log("添加模板");
          this.$message.success(res.data.msg);
          this.getMatMarkMaterialList(param.stepId);
          this.closeSonUpdate();
          this.closeIncreaseModelOrPrecssOrSetpStatus();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    closeSonUpdate() {
      if (this.$refs.wangeditor) {
        this.$refs.wangeditor.clearText();
      }
      this.resetFrom();
      this.fileList = [];
      this.innerSonDrawer = false;
    },
    resetFrom() {
      this.matForm = {
        matId: "",
        matImg: "",
        matInfo: "",
        matStyle: 1,
        status: 0,
        stepId: 0,
      };
    },
    // 移除模块/流程/步骤
    removeModelOrPrecssOrSetp(item, type) {
      if (item == null) {
        this.$message.warning("参数不存在，请刷新重试哦");
        return;
      }
      var url = "/api/source/" + type + "/deleteByPk/" + item.id;
      // 进行请求
      this.$http.get(url, {}).then((res) => {
        if (res.data.status == 0) {
          this.$message.success(res.data.msg);
          switch (type) {
            case "matMarkModular":
              this.getMatMarkModularList(item.activityId);
              break;
            case "matMarkProcess":
              this.getMatmatMarkProcessList(item.modularId);
              break;
            case "matMarkStep":
              this.getMatMarkStepList(item.processId);
              break;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 增加模块/流程/步骤
    increaseModelOrPrecssOrSetp(item, type) {
      // type:  matMarkModular   matMarkProcess  matMarkStep
      // method  insert   update
      switch (type) {
        case "matMarkModular":
          item != null
            ? (this.incParam = {
                type: "matMarkModular",
                addMOPOSTitle: "修改一下模块",
                addMOPOSInputName: "模块名称：",
                name: item.modularName,
                id: item.id,
                timeVlaue: [item.startTime, item.endTime],
              })
            : (this.incParam = {
                type: "matMarkModular",
                addMOPOSTitle: "新增一个模块",
                addMOPOSInputName: "模块名称：",
                name: "",
                id: null,
                timeVlaue: [],
              });
          this.increaseModelOrPrecssOrSetpStatus = true;
          break;
        case "matMarkProcess":
          item != null
            ? (this.incParam = {
                type: "matMarkProcess",
                addMOPOSTitle: "修改一下流程",
                addMOPOSInputName: "流程名称：",
                name: item.processName,
                id: item.id,
                timeVlaue: [item.startTime, item.endTime],
              })
            : (this.incParam = {
                type: "matMarkProcess",
                addMOPOSTitle: "新增一个流程",
                addMOPOSInputName: "流程名称：",
                name: "",
                id: null,
                timeVlaue: [],
              });
          this.increaseModelOrPrecssOrSetpStatus = true;
          break;
        case "matMarkStep":
          console.log(item);

          if (item != null && item.spuList == null) item.spuList = [];
          item != null
            ? (this.incParam = {
                type: "matMarkStep",
                addMOPOSTitle: "修改一下步骤",
                addMOPOSInputName: "步骤名称：",
                goodsInputName: "商品ID",
                goodsId: "",
                spuList: item.spuList,
                name: item.stepName,
                id: item.id,
                timeVlaue: [item.startTime, item.endTime],
              })
            : (this.incParam = {
                type: "matMarkStep",
                addMOPOSTitle: "新增一个步骤",
                addMOPOSInputName: "步骤名称：",
                goodsInputName: "商品ID",
                goodsId: "",
                spuList: [],
                name: "",
                id: null,
                timeVlaue: [],
              });
          this.increaseModelOrPrecssOrSetpStatus = true;
          break;
      }
    },
    // 增加的方法（组装URL以及参数）
    operationMatMark() {
      var incParam = this.incParam;
      console.log(incParam);
      if ("" == incParam.name || null == incParam.name) {
        this.$message.warning("不能为空哦，请输入内容");
        return;
      }
      if (
        this.incParam.timeVlaue == [] ||
        this.incParam.timeVlaue.length == 0
      ) {
        this.$message.warning("请选择时间");
        return;
      }
      var param = null;
      var url = "/api/plant/";
      console.log(this.incParam.timeVlaue);
      switch (incParam.type) {
        case "matMarkModular":
          if (this.MatMarkModularList.length > 0) {
            var nextEnd =
              this.MatMarkModularList[this.MatMarkModularList.length - 1]
                .endTime;
            if (incParam.id == null) {
              if (+new Date(nextEnd) >= +new Date(incParam.timeVlaue[0])) {
                return this.$message.error(
                  `当前所选择的时间应在上一个模块结束时间 ${nextEnd.substr(
                    0,
                    10
                  )}（不包含） 之后！`
                );
              }
            } else {
              var index = this.MatMarkModularList.findIndex(
                (item) => item.id == incParam.id
              );
              if (index <= 0 && this.MatMarkModularList.length > 1) {
                let nextStart = +new Date(
                  this.MatMarkModularList[index + 1].startTime
                );
                if (!(+new Date(this.incParam.timeVlaue[1]) < nextStart)) {
                  return this.$message.error(
                    `当前模块修改的结束时间应该在 ${this.MatMarkModularList[
                      index + 1
                    ].startTime.substr(0, 10)}（不包含） 之前`
                  );
                }
              } else if (
                index == this.MatMarkModularList.length - 1 &&
                this.MatMarkModularList.length > 1
              ) {
                let topEnd = +new Date(
                  this.MatMarkModularList[index - 1].endTime
                );
                if (!(+new Date(this.incParam.timeVlaue[0]) > topEnd)) {
                  return this.$message.error(
                    `当前模块修改的开始时间应该在 ${this.MatMarkModularList[
                      index - 1
                    ].endTime.substr(0, 10)}（不包含） 之后`
                  );
                }
              } else if (this.MatMarkModularList.length > 2) {
                let shangEnd = +new Date(
                  this.MatMarkModularList[index - 1].endTime
                );
                let xiaStart = +new Date(
                  this.MatMarkModularList[index + 1].startTime
                );
                if (
                  !(
                    +new Date(this.incParam.timeVlaue[0]) > shangEnd &&
                    +new Date(this.incParam.timeVlaue[1]) < xiaStart
                  )
                ) {
                  return this.$message.error(
                    `当前模块的修改时间范围应该在 ${this.MatMarkModularList[
                      index - 1
                    ].endTime.substr(
                      0,
                      10
                    )}(不包含) 一 ${this.MatMarkModularList[
                      index + 1
                    ].startTime.substr(0, 10)}（不包含） 之间`
                  );
                }
              }
            }
          }
          param = {
            activityId: this.ActivityForm.id,
            id: incParam.id,
            modularName: incParam.name,
            status: 0,
            delete_status: 0,
            startTime: this.incParam.timeVlaue[0],
            endTime: this.incParam.timeVlaue[1],
          };
          incParam.id == null
            ? (param.orders = this.MatMarkModularList.length)
            : "";
          url =
            url +
            incParam.type +
            "/" +
            (incParam.id == null ? "insertModular" : "updateModular");
          break;
        case "matMarkProcess":
          var index = this.MatMarkModularList.findIndex(
            (item) => item.id == this.MatMarkModularId
          );
          var fatherStart = +new Date(this.MatMarkModularList[index].startTime);
          var fatherEnd = +new Date(this.MatMarkModularList[index].endTime);

          var index2 = this.matMarkProcessList.findIndex(
            (item) => item.id == incParam.id
          );
          if (incParam.id == null) {
            if (this.matMarkProcessList.length < 1) {
              if (
                !(
                  +new Date(this.incParam.timeVlaue[0]) >= fatherStart &&
                  +new Date(this.incParam.timeVlaue[1]) <= fatherEnd
                )
              ) {
                return this.$message.error(
                  `当前所选时间应该在所属模块的时间${this.MatMarkModularList[
                    index
                  ].startTime.substr(0, 10)} (包含)- ${this.MatMarkModularList[
                    index
                  ].endTime.substr(0, 10)}（包含）范围之内！`
                );
              }
            } else {
              var nextEnd =
                this.matMarkProcessList[this.matMarkProcessList.length - 1]
                  .endTime;
              console.log(nextEnd);
              if (fatherEnd == +new Date(nextEnd)) {
                return this.$message.error("当前时间段已经创建流程~");
              } else if (
                !(
                  +new Date(this.incParam.timeVlaue[1]) <= fatherEnd &&
                  +new Date(this.incParam.timeVlaue[0]) > +new Date(nextEnd)
                )
              ) {
                return this.$message.error(
                  `当前所选时间应该在所属模块的时间${nextEnd.substr(
                    0,
                    10
                  )}（不包含） - ${this.MatMarkModularList[
                    index
                  ].endTime.substr(0, 10)}（包含）范围之内！`
                );
              }
            }
          } else {
            console.log(index2);
            if (this.matMarkProcessList.length == 1) {
              if (
                !(
                  +new Date(this.incParam.timeVlaue[0]) >= fatherStart &&
                  +new Date(this.incParam.timeVlaue[1]) <= fatherEnd
                )
              ) {
                return this.$message.error(
                  `当前所选时间应该在所属模块的时间${this.MatMarkModularList[
                    index
                  ].startTime.substr(
                    0,
                    10
                  )}（包含） - ${this.MatMarkModularList[index].endTime.substr(
                    0,
                    10
                  )}（包含）范围之内！`
                );
              }
            } else if (index2 <= 0 && this.matMarkProcessList.length > 1) {
              let nextStart = +new Date(
                this.matMarkProcessList[index2 + 1].startTime
              );
              if (
                !(
                  +new Date(this.incParam.timeVlaue[1]) < nextStart &&
                  +new Date(this.incParam.timeVlaue[0]) >= fatherStart
                )
              ) {
                console.log(this.matMarkProcessList[index2 + 1].startTime);
                return this.$message.error(
                  `当前活动流程修改的时间应该在 ${this.MatMarkModularList[
                    index
                  ].startTime.substr(0, 10)}(包含) - ${this.matMarkProcessList[
                    index2 + 1
                  ].startTime.substr(0, 10)}(不包含) 范围之内`
                );
              }
            } else if (
              index2 == this.matMarkProcessList.length - 1 &&
              this.matMarkProcessList.length > 1
            ) {
              let topEnd = +new Date(
                this.matMarkProcessList[index2 - 1].endTime
              );
              if (
                !(
                  +new Date(this.incParam.timeVlaue[0]) > topEnd &&
                  fatherEnd >= +new Date(this.incParam.timeVlaue[1])
                )
              ) {
                return this.$message.error(
                  `当前活动流程修改的时间范围应该在 ${this.matMarkProcessList[
                    index2 - 1
                  ].endTime.substr(
                    0,
                    10
                  )}（不包含） - ${this.MatMarkModularList[
                    index
                  ].endTime.substr(0, 10)}(包含) 之间`
                );
              }
            } else if (this.matMarkProcessList.length > 2) {
              let shangEnd = +new Date(
                this.matMarkProcessList[index2 - 1].endTime
              );
              let xiaStart = +new Date(
                this.matMarkProcessList[index2 + 1].startTime
              );
              if (
                !(
                  +new Date(this.incParam.timeVlaue[0]) > shangEnd &&
                  +new Date(this.incParam.timeVlaue[1]) < xiaStart
                )
              ) {
                return this.$message.error(
                  `当前活动流程的修改时间范围应该在 ${this.matMarkProcessList[
                    index2 - 1
                  ].endTime.substr(
                    0,
                    10
                  )}（不包含） - ${this.matMarkProcessList[
                    index2 + 1
                  ].startTime.substr(0, 10)}（不包含） 之间`
                );
              }
            }
          }

          param = {
            modularId: this.MatMarkModularId,
            id: incParam.id,
            processName: incParam.name,
            status: 0,
            delete_status: 0,
            startTime: this.incParam.timeVlaue[0],
            endTime: this.incParam.timeVlaue[1],
          };
          incParam.id == null
            ? (param.orders = this.matMarkProcessList.length)
            : "";
          url =
            url +
            "matMarkModular/" +
            (incParam.id == null ? "insertProcess" : "updateProcess");
          break;
        case "matMarkStep":
          param = {
            processId: this.matMarkProcessId,
            id: incParam.id,
            stepName: incParam.name,
            status: 0,
            delete_status: 0,
            spuList: incParam.spuList,
            startTime: this.incParam.timeVlaue[0],
            endTime: this.incParam.timeVlaue[1],
          };
          incParam.id == null
            ? (param.orders = this.MatMarkStepList.length)
            : "";
          url =
            url +
            "matMarkModular" +
            "/" +
            (incParam.id == null ? "insertStep" : "updateStep");
          break;
      }
      if (null == param || "/api/source/" == url) {
        this.$message.warning("参数错误，请您关闭后重试");
        return;
      }
      this.incOrUpdateMatMark(param, url);
    },
    // 新增或修改的方法
    incOrUpdateMatMark(param, url) {
      // 进行请求
      this.$http
        .post(url, param)
        .then((res) => {
          if (res.data.status == 0) {
            this.$message.success(res.data.msg);
            switch (this.incParam.type) {
              case "matMarkModular":
                console.log("添加模块");
                this.getMatMarkModularList(param.activityId);
                break;
              case "matMarkProcess":
                this.getMatmatMarkProcessList(param.modularId);
                break;
              case "matMarkStep":
                this.getMatMarkStepList(param.processId);
                break;
            }
            this.closeIncreaseModelOrPrecssOrSetpStatus();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          if (url == "/api/plant/matMarkModular/updateStep")
            return this.$message.warning("请添加正确的商品ID");
        });
    },
    // colse 新增修改模块
    closeIncreaseModelOrPrecssOrSetpStatus() {
      this.incParam = {
        addMOPOSTitle: "",
        addMOPOSInputName: "",
        name: "",
        id: null,
        pid: "",
        type: "",
      };
      this.increaseModelOrPrecssOrSetpStatus = false;
    },
    // 模块被点击
    changeMatMarkModular(MatMarkModularId) {
      this.MatMarkModularId = MatMarkModularId;
      this.getMatmatMarkProcessList(this.MatMarkModularId);
    },
    // 流程被点击
    changeMatMarkProcess(matMarkProcessId) {
      this.matMarkProcessId = matMarkProcessId;
      this.getMatMarkStepList(this.matMarkProcessId);
    },
    // 步骤被点击
    changeMatMarkStep(MatMarkStepId) {
      this.MatMarkStepId = MatMarkStepId;
      this.getMatMarkMaterialList(this.MatMarkStepId);
    },
    // 监听块被移动
    listenDragging() {
      this.$dragging.$on("dragged", ({ value }) => {
        this.moveData(value);
      });
    },
    moveData(value) {
      if (this.changeList == JSON.stringify(value)) {
        return;
      }
      this.changeList = JSON.stringify(value);
      if (this.setListenDragging) {
        console.log("清除定时器：", this.setListenDragging);
        clearTimeout(this.setListenDragging);
      }
      this.setListenDragging = setTimeout(() => {
        //    组装参数
        var methodName = value.group;
        var changeList = [];
        value.list.forEach((element, index) => {
          if (element.orders != index) {
            changeList.push({
              id: element.id,
              orders: index,
            });
          }
        });
        if (changeList.length > 0) {
          this.$http
            .post(
              "/api/source/matMarkModular/sort?methodName=" + methodName,
              changeList
            )
            .then((res) => {
              if (res.data.status == 0) {
                this.$message.success(res.data.msg);
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      }, 2000);
      console.log("创建了定时器", this.setListenDragging);
    },
    // 请求一个SOP的基本模块信息fg
    getMatMarkModularList(activityId) {
      this.MatMarkModularLoading = true;
      this.$http
        .get("/api/plant/matMarkModular/list/" + activityId, {})
        .then((res) => {
          if (res.data.status == 0) {
            console.log(res.data, "数据");
            this.MatMarkModularList = res.data.data;
            if (this.MatMarkModularList.length > 0) {
              this.MatMarkModularId = this.MatMarkModularList[0].id;
              this.getMatmatMarkProcessList(this.MatMarkModularId);
            } else {
              // 没有数据
              this.reSetMatMarkModular();
              this.reSetMatMarkProcess();
              this.reSetMatMarkStep();
              this.reSetMatMarkMaterial();
            }
          } else {
            this.$message.error(res.data.msg);
          }
          this.MatMarkModularLoading = false;
        });
    },
    // 获取流程
    getMatmatMarkProcessList(modularId) {
      this.matMarkProcessLoading = true;
      this.$http
        .get("/api/plant/matMarkModular/listProcess/" + modularId, {})
        .then((res) => {
          if (res.data.status == 0) {
            this.matMarkProcessList = res.data.data;
            if (this.matMarkProcessList.length > 0) {
              this.matMarkProcessId = this.matMarkProcessList[0].id;
              this.getMatMarkStepList(this.matMarkProcessId);
            } else {
              // 没有数据
              this.reSetMatMarkProcess();
              this.reSetMatMarkStep();
              this.reSetMatMarkMaterial();
            }
          } else {
            this.$message.error(res.data.msg);
          }
          this.matMarkProcessLoading = false;
        });
    },
    // 获取步骤
    getMatMarkStepList(processId) {
      this.MatMarkStepLoading = true;
      this.$http
        .get("/api/plant/matMarkModular/listStep/" + processId, {})
        .then((res) => {
          if (res.data.status == 0) {
            this.MatMarkStepList = res.data.data;
            console.log(this.MatMarkStepList, "步骤");
            if (this.MatMarkStepList.length > 0) {
              this.MatMarkStepId = this.MatMarkStepList[0].id;
              this.getMatMarkMaterialList(this.MatMarkStepId);
            } else {
              // 没有数据
              this.reSetMatMarkStep();
              this.reSetMatMarkMaterial();
            }
          } else {
            this.$message.error(res.data.msg);
          }
          this.MatMarkStepLoading = false;
        });
    },
    // 获取素材
    getMatMarkMaterialList(stepId) {
      this.MatMarkMaterialLoading = true;
      this.$http
        .get("/api/source/matMarkMaterial/list/" + stepId, {})
        .then((res) => {
          if (res.data.status == 0) {
            this.MatMarkMaterialList = res.data.data;
            console.log(res.data.data);
            if (this.MatMarkStepList.length <= 0) {
              // 没有数据
              this.reSetMatMarkMaterial();
            }
          } else {
            this.$message.error(res.data.msg);
          }
          this.MatMarkMaterialLoading = false;
        });
    },
    reSetMatMarkModular() {
      this.MatMarkModularLoading = false;
      this.MatMarkModularList = [];
      this.MatMarkModularId = "";
    },
    reSetMatMarkProcess() {
      this.matMarkProcessLoading = false;
      this.matMarkProcessList = [];
      this.matMarkProcessId = "";
    },
    reSetMatMarkStep() {
      this.MatMarkStepLoading = false;
      this.MatMarkStepList = [];
      this.MatMarkStepId = "";
    },
    reSetMatMarkMaterial() {
      this.MatMarkMaterialLoading = false;
      this.MatMarkMaterialList = [];
      this.MatMarkMaterialId = "";
    },
    // SOP管理区域
    openChapterDrawer(row) {
      this.radioValue = 0;
      if (null != row) {
        this.title = row.activityName;
        this.ActivityForm = row;
        this.testpaperDrawer = true;
        this.getMatMarkModularList(row.id);
      } else {
        this.$message.warning("信息错误，请刷新页面");
      }
    },
    // 以下为活动列表查询方法区域-------------------------
    openActivity(row, showPop) {
      this.radioValue = 0;
      if (null != row) {
        row.activityPicList = [
          {
            url: row.activityPic,
          },
        ];
        // 把数列数据进行重组
        row.userTypeLabelLi = [];
        row.userAppealLabelLi = [];
        row.userTypeLabels = [];
        row.userAppealLabels = [];
        if (row.matMarkActivityLabels != null) {
          row.matMarkActivityLabels.forEach((element) => {
            if (element.labelType == 1) {
              // 用户特征
              row.userTypeLabelLi.push(element);
            }
            if (element.labelType == 2) {
              // 用户特征
              row.userAppealLabelLi.push(element);
            }
          });
          row.userTypeLabels = row.userTypeLabelLi;
          row.userAppealLabels = row.userAppealLabelLi;
          var newUserTypeLabels = [];
          row.userTypeLabelLi.forEach((element) => {
            console.log(element);
            newUserTypeLabels.push({
              dicDesc: element.labelDesc,
              dicId: element.labelValue,
            });
          });
          row.userTypeLabels = newUserTypeLabels;

          var newUserAppealLabels = [];
          row.userAppealLabelLi.forEach((element) => {
            console.log(element);
            newUserAppealLabels.push({
              dicDesc: element.labelDesc,
              dicId: element.labelValue,
            });
          });
          row.userAppealLabels = newUserAppealLabels;
        }
        console.log(row);
        this.ActivityForm = row;
        this.hideUpload = true;
      }
      if (showPop == 1) return;
      this.ActivityFormVisible = !this.ActivityFormVisible;
    },
    submitFromData(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //验证通过
          console.log(this.ActivityForm);
          var newobj = {
            ...this.ActivityForm,
            activityPic: this.ActivityForm.activityPicList[0].url,
          };
          var url =
            "/api/plant/matMarkModular/" +
            (newobj.id == "" ? "insertActivity" : "updateActivity");
          var matMarkActivityLabels = [];
          if (newobj.userAppealLabels.length > 0) {
            newobj.userAppealLabels.forEach((element) => {
              var thisP = {
                labelType: 2,
                labelValue: element.dicId,
                labelDesc: element.dicDesc,
              };
              if (newobj.id != null && newobj.id != "") {
                thisP.activityId = newobj.id;
              }
              matMarkActivityLabels.push(thisP);
            });
          }
          if (newobj.userTypeLabels.length > 0) {
            newobj.userTypeLabels.forEach((element) => {
              var thisP = {
                labelType: 1,
                labelValue: element.dicId,
                labelDesc: element.dicDesc,
              };
              if (newobj.id != null && newobj.id != "") {
                thisP.activityId = newobj.id;
              }
              matMarkActivityLabels.push(thisP);
            });
          }
          newobj.matMarkActivityLabels = matMarkActivityLabels;
          this.$http.post(url, newobj).then((res) => {
            if (res.data.status == 0) {
              this.handleSizeChange();
              this.offDialog();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.data.msg || "请求错误");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    offDialog() {
      this.resetActivityForm();
      this.hideUpload = false;
      this.ActivityFormVisible = false;
    },
    query() {
      this.searchForm.pageNum = this.pageNum;
      this.searchForm.pageSize = this.pageSize;
      this.$http
        .post("/api/plant/matMarkModular/listPage", this.searchForm)
        .then((res) => {
          if (res.data.status == 0) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    closeTestpaperDrawer() {
      this.resetActivityForm();
      this.testpaperDrawer = false;
    },
    // 分页组件
    handleSizeChange(val) {
      this.pageNum = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.query();
    },
    //添加话题时 获取上传图片的数据
    getPictrueURL(response, file, fileList) {
      // console.log(fileList,'真烦');
      this.ActivityForm.activityPicList = [
        {
          url: response.data,
        },
      ];
    },

    // 获取图片地址，调用接口后端返回上传地址
    getMatPictrueURL(response, file, fileList) {
      let files = this.matForm.matImg.split(",");
      files.push(response.data);
      this.matForm.matImg = files.length === 0 ? "" : files.join(",");
    },
    // 图片错误的钩子
    handleError(err, file, fileList) {
      err = err + "a";
      if (err.search("413") != -1) {
        this.$message.error("抱歉，文件过大，无法上传");
      } else {
        this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
      }
    },
    //图片移除钩子
    handleRemove(file, fileList) {
      this.ActivityForm.activityPicList = fileList;
      console.log(this.ActivityForm.activityPicList.length);
      this.hideUpload = false;
    },
    handleMatRemove(file, fileList) {
      let files = this.matForm.matImg.split(",");
      files.splice(files.indexOf(file.url), 1);
      this.matForm.matImg = files.length === 0 ? "" : files.join(",");
    },
    //上传图片时触发
    uponChange(file, fileList) {
      this.hideUpload = fileList.length >= 1;
    },
    // 初始化活动的对象
    resetActivityForm() {
      this.ActivityForm = {
        activityName: "",
        activityInfo: "",
        activityPic: "",
        activityPicList: [],
        status: 0,
        id: "",
        userTypeLabels: [], //用户特征标签组
        userAppealLabels: [], //用户诉求标签组
      };
    },
    // 两个贼TM烦人的标签
    searchFromChange(id) {
      let typeElement = null;
      switch (id) {
        case 1:
          this.userAppealLabelsList.forEach((element) => {
            if (element.dicId == this.userAppealLabels) {
              typeElement = element;
            }
          });
          if (typeElement != null) {
            let indexIf = 0;
            this.ActivityForm.userAppealLabels.forEach((element) => {
              if (element.dicId == typeElement.dicId) {
                indexIf++;
              }
            });
            indexIf == 0
              ? this.ActivityForm.userAppealLabels.push(typeElement)
              : this.$message.error("已存在该标签");
          }
          this.$forceUpdate();
          break;
        case 2:
          this.userTypeLabelsList.forEach((element) => {
            if (element.dicId == this.userTypeLabels) {
              typeElement = element;
            }
          });
          if (typeElement != null) {
            let indexIf = 0;
            this.ActivityForm.userTypeLabels.forEach((element) => {
              if (element.dicId == typeElement.dicId) {
                indexIf++;
              }
            });
            indexIf == 0
              ? this.ActivityForm.userTypeLabels.push(typeElement)
              : this.$message.error("已存在该标签");
          }
          this.$forceUpdate();
          break;
      }
    },
    // 获取一系列的标签
    getScatteredDicAll() {
      this.loading = true;
      var dicTypeS = [1, 2];
      var dicTypeValue = {
        1: 180,
        2: 179,
      };
      dicTypeS.forEach((element) => {
        this.$http
          .get(
            "/api/source/matDic/selectByParentId?pid=" + dicTypeValue[element],
            {}
          )
          .then((res) => {
            switch (element) {
              case 1:
                this.userAppealLabelsList = res.data.data;
                break;
              case 2:
                this.userTypeLabelsList = res.data.data;
                break;
            }
          })
          .finally((res) => {});
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .el-menu .el-menu--inline {
  height: 100%;
}

/deep/.hide .el-upload--picture-card {
  display: none;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.width-100 {
  width: 100%;
}

.margin-top {
  margin-top: 15px;
}

.back-color-gray {
  background: #80808004;
}

.change-div {
  font-size: 12px;
}

.change-div button {
  margin-left: 15px;
}

.flex-space-around {
  display: flex;
}

.padding-lr-20 {
  padding: 0px 20px;
}

.padding-tb-20 {
  padding: 10px 0px;
}

/deep/.el-input {
  height: auto;
}

.flex2 {
  display: flex;
  flex-direction: column;
}

.chaochu {
  width: 200px;
  overflow: hidden;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.close {
  position: absolute;
  right: -5px;
  top: -5px;
  color: black;
}
.biaoqian {
  display: inline-block;
  margin-left: 10px;
  background-color: #ecf5ff;
  color: #4ea5ff;
  padding: 5px;
  border-radius: 5px;
  position: relative;
}
</style>
